import React from 'react';
import { useTranslation } from 'react-i18next';

const WhyFBS: React.FC = () => {
  const { t } = useTranslation();

  const advantages = [
    {
      title: t('whyfbs.adv1title'),
      description: t('whyfbs.adv1desc'),
      value: '15+',
      unit: t('whyfbs.adv1unit')
    },
    {
      title: t('whyfbs.adv2title'),
      description: t('whyfbs.adv2desc'),
      value: '200+',
      unit: t('whyfbs.adv2unit')
    },
    {
      title: t('whyfbs.adv3title'),
      description: t('whyfbs.adv3desc'),
      value: '2h',
      unit: t('whyfbs.adv3unit')
    },
    {
      title: t('whyfbs.adv4title'),
      description: t('whyfbs.adv4desc'),
      value: '100%',
      unit: t('whyfbs.adv4unit')
    }
  ];

  return (
    <section id="about" className="section-padding">
      <div className="container-custom">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('whyfbs.title')}
          </h2>
          <p className="text-base sm:text-xl text-gray-300 max-w-3xl mx-auto">
            {t('whyfbs.description')}
          </p>
        </div>

        {/* Advantages grid */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-8 mb-12 sm:mb-16">
          {advantages.map((advantage, index) => (
            <div key={index} className="text-center">
              <div className="mb-6">
                <div className="text-3xl sm:text-4xl md:text-5xl font-bold text-accent-green mb-2">
                  {advantage.value}
                </div>
                <div className="text-sm text-gray-400 uppercase tracking-wide">
                  {advantage.unit}
                </div>
              </div>
              <h3 className="text-lg font-semibold text-white mb-3">
                {advantage.title}
              </h3>
              <p className="text-gray-300 text-sm leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>

        {/* Technical specifications and CTA - Side by side */}
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          {/* Left: Technical specifications */}
          <div className="max-w-2xl mx-auto lg:mx-0 w-full">
            <div className="tech-card border-accent-green/50">
              <h3 className="text-xl font-semibold text-white mb-6 flex items-center">
                <span className="text-2xl mr-3">🔧</span>
                {t('whyfbs.techCompetences')}
              </h3>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-accent-green rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="text-white font-medium mb-1">{t('whyfbs.projectDocs')}</div>
                    <div className="text-gray-400 text-sm">{t('whyfbs.projectDocsDesc')}</div>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-accent-green rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="text-white font-medium mb-1">{t('whyfbs.riskAnalysis')}</div>
                    <div className="text-gray-400 text-sm">{t('whyfbs.riskAnalysisDesc')}</div>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-accent-green rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="text-white font-medium mb-1">{t('whyfbs.perfOptimization')}</div>
                    <div className="text-gray-400 text-sm">{t('whyfbs.perfOptimizationDesc')}</div>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-accent-green rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <div className="text-white font-medium mb-1">{t('whyfbs.systemIntegration')}</div>
                    <div className="text-gray-400 text-sm">{t('whyfbs.systemIntegrationDesc')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: CTA */}
          <div className="flex flex-col justify-center space-y-8">
            {/* Email CTA */}
            <div className="max-w-xl mx-auto lg:mx-0 w-full">
              <p className="text-gray-400 text-sm mb-4 text-center lg:text-left">
                {t('whyfbs.ctaDescription')}
              </p>
              <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
                <input
                  type="email"
                  placeholder={t('hero.emailPlaceholder')}
                  className="flex-1 px-5 py-3 bg-[#161616] border border-[#2a2a2a] rounded-full text-white placeholder-gray-500 focus:border-accent-green focus:outline-none text-sm"
                />
                <button className="px-6 py-3 bg-accent-green hover:bg-[#d4ff33] text-black font-semibold rounded-full transition-colors duration-300 text-sm whitespace-nowrap">
                  {t('hero.contactBtn')}
                </button>
              </div>
            </div>
            
            <div className="flex justify-center lg:justify-start">
              <button className="btn-primary">
                {t('whyfbs.requestReferences')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyFBS;
